

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  inheritAttrs: false,
  computed: {
    ...mapState({
      loading: 'loading',
    }),
  },
})
export default class QDownloadBtn extends Vue {
  @Prop({ default: 280 }) readonly minWidth!: string | number;

  @Prop({ default: 280 }) readonly maxWidth!: string | number;

  @Prop({ default: 10000 }) readonly timeout!: string | number;

  @Prop({ default: 'Download' }) readonly buttonText!: string;

  @Prop({ required: true, type: Function })
  readonly downloadHandler!: () => Promise<any>;

  downloading = false;

  handleDownload() {
    this.downloading = true;

    this.downloadHandler().then(() => {
      this.downloading = false;
    });
  }
}
